import { Dropdown } from "react-bootstrap";
import styles from "../leaderboard.module.css";
import { MoreVertical, Slash, X } from "react-feather";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Tooltip,
} from "@mui/material";
import { useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { toast } from "react-smart-toaster";
import { useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";

const ProspectCard = ({
  item,
  setLoading,
  setLeaderboards,
  setOpenProspectDetails,
  setSelectProspectId,
  setOpenCallModal,
  setProspectInfoObj,
}) => {
  const voiceCallInfo = useSelector(
    (store) => store.communicationVoiceCallInfoReducer
  );
  const { getAccessTokenSilently } = useAuth0();
  const [openLeaderBoardModal, setOpenLeaderBoardModal] = useState(false);
  const history = useHistory();

  const removeFromLeaderBoard = async () => {
    let id;

    if (item?.type === "tenant") {
      id = item?.tenant_id;
    } else {
      id = item?.applicant_id;
    }

    setLoading(true);
    setOpenLeaderBoardModal(false);

    const token = await getAccessTokenSilently({
      audience: process.env.REACT_APP_AUTH0_AUDIENCE,
    });

    return axios
      .delete(
        process.env.REACT_APP_APPLICANT_API_URL +
        "v1/remove-from-leaderboard/" +
        id +
        "/" +
        item?.type,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        setLoading(false);

        setLeaderboards((prev) => {
          if (item?.type === "tenant") {
            return prev?.filter((i) => i?.tenant_id !== item?.tenant_id);
          } else {
            return prev?.filter((i) => i?.applicant_id !== item?.applicant_id);
          }
        });
      })
      .catch((error) => {
        setLoading(false);
        if (typeof error.response !== "undefined")
          toast.error(error.response.data.message);
      });
  };

  const initiateVoiceCall = (item) => {
    if (voiceCallInfo) {
      toast.error("You are on anotehr call.");
    } else {
      setOpenCallModal(true);
      setProspectInfoObj({
        id: item?.applicant_id,
        full_name: item?.full_name,
        initial: item?.initial,
        phone: item?.phone,
        user_avatar: item?.user_avatar,
      });
    }
  };

  const getSlaTooltipData = (item) => {
    let txt = "Salary - N/A";
    let txt2 = "";
    if (item?.income_type === "Voucher") {
      txt = "Voucher - $" + item?.formatted_voucher_amount;
    } else if (item?.income_per_year !== "") {
      txt = "Salary - $" + item?.formatted_income_per_year;
    }

    if (item?.is_employement2 === 1) {
      if (item?.income_type2 === "Voucher" && item?.voucher_amount2 !== "") {
        txt2 = "Voucher2 - " + new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        }).format(item?.voucher_amount2);
      } else if (item?.income_per_year2 !== "") {
        txt2 = "Salary2 - " + new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        }).format(item?.income_per_year2);
      }
    }

    return <div>{txt}<br />{txt2}</div>;
  }

  return (
    <>
      <div
        onClick={(e) => {
          if (item?.type === "prospect") {
            setOpenProspectDetails(true);
            setSelectProspectId(item?.applicant_id);
          } else {
            const redirectRoute = `/people/tenants/details/${item?.tenant_id}`;

            history.push(redirectRoute);
          }
        }}
        style={{ cursor: "pointer" }}
      >
        <div className={`${styles.ProspectCardHeadSectionSS}`}>
          <div className={`${styles.ProsIMGSec}`}>
            {item?.user_avatar !== "" ? (
              <img
                src={item?.user_avatar}
                className={`${styles.defaultImg}`}
                alt=""
              />
            ) : item?.initial !== "?" ? (
              <p>{item?.initial}</p>
            ) : (
              <img
                src="/static/img/DefaultLogo.png"
                className={`${styles.defaultImg}`}
                alt=""
              />
            )}
          </div>
          <div className={`${styles.HeadConSec}`}>
            <div className={`${styles.prospectNameActionSec}`}>
              <p className={`${styles.ProsUserName} ${styles.LimitName}`}>
                {" "}
                {item?.full_name !== ""
                  ? item?.type === "tenant" && item?.no_of_tenant > 1
                    ? item?.full_name + " +" + (item?.no_of_tenant - 1)
                    : item?.full_name
                  : "-"}{" "}
              </p>
              <p className={`${styles.ProsUnitName}`}>
                {item?.apt_no && item?.apt_no !== "" ? item?.apt_no : ""}
              </p>
              <Dropdown
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation(e);
                }}
              >
                <Dropdown.Toggle
                  className={`${styles.ActionsBU} ProsDrBU`}
                  id="dropdown-basic"
                >
                  <MoreVertical />
                </Dropdown.Toggle>

                <Dropdown.Menu
                  className={`${styles.ActionsBUList} ActionsBUList`}
                >
                  <Dropdown.Item
                    className={`${styles.ActionsBUListItem}`}
                    onClick={(e) => setOpenLeaderBoardModal(true)}
                  >
                    <Slash /> Remove from Leaderboard
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <div className={`${styles.prospectNameActionSec}`}>
              <Tooltip title="Start a voice call">
                <p
                  className={`${styles.ProsUserName} ${styles.CallLink}`}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation(e);
                    initiateVoiceCall(item);
                  }}
                >
                  {item?.phone}
                </p>
              </Tooltip>
              {item?.current_status === 0 && (
                <span className={`${styles.ProspectNonAppliedBadge}`}>
                  Not Applied
                </span>
              )}
              {item?.current_status === 1 && (
                <span className={`${styles.ProspectAppliedBadge}`}>
                  Applied
                </span>
              )}
              {item?.current_status === 2 && (
                <span className={`${styles.ProspectScreenedBadge}`}>
                  Screened
                </span>
              )}
              {item?.current_status === 3 && (
                <span className={`${styles.ProspectApprovedBadge}`}>
                  Approved
                </span>
              )}
              {item?.current_status === 4 && (
                <span className={`${styles.ProspectDeclinedBadge}`}>
                  Declined
                </span>
              )}
              {item?.type === "tenant" && (
                <span className={`${styles.ProspectTenantBadge}`}>Tenant</span>
              )}
            </div>
            {/* {item?.type === "prospect" && (
              <div className={`${styles.ProsUserMandateSec}`}>
                <Tooltip
                  title={
                    item?.credit_score !== ""
                      ? "Credit Score - " + item?.credit_score
                      : "Credit Score - N/A"
                  }
                >
                  <span
                    className={
                      item?.check_list?.credit_score === 2
                        ? `${styles.MandateCheckSec} ${styles.Fail}`
                        : item?.check_list?.credit_score === 1
                        ? `${styles.MandateCheckSec} ${styles.Active}`
                        : `${styles.MandateCheckSec}`
                    }
                  >
                    <img src="/static/img/credit-score-icon.svg" alt="" />
                  </span>
                </Tooltip>
                <Tooltip
                  title={
                    item?.income_type === "Voucher"
                      ? item?.voucher_amount !== ""
                        ? "Voucher - $" + item?.formatted_voucher_amount
                        : "Voucher - N/A"
                      : item?.income_per_year !== ""
                      ? "Salary - $" + item?.formatted_income_per_year
                      : "Salary - N/A"
                  }
                >
                  <span
                    className={
                      item?.check_list?.income === 2
                        ? `${styles.MandateCheckSec} ${styles.Fail}`
                        : item?.check_list?.income === 1
                        ? `${styles.MandateCheckSec} ${styles.Active}`
                        : `${styles.MandateCheckSec}`
                    }
                  >
                    <img src="/static/img/salary-icon.svg" alt="" />
                  </span>
                </Tooltip>
                <Tooltip
                  title={
                    item?.ever_had_bankruptcy !== ""
                      ? "Bankruptcy - " + item?.ever_had_bankruptcy
                      : "Bankruptcy - N/A"
                  }
                >
                  <span
                    className={
                      item?.check_list?.bankruptcy === 2
                        ? `${styles.MandateCheckSec} ${styles.Fail}`
                        : item?.check_list?.bankruptcy === 1
                        ? `${styles.MandateCheckSec} ${styles.Active}`
                        : `${styles.MandateCheckSec}`
                    }
                  >
                    <img src="/static/img/bankruptcy-icon.svg" alt="" />
                  </span>
                </Tooltip>
                <Tooltip
                  title={
                    item?.ever_case_filed !== ""
                      ? "Housing Court Cases - " + item?.ever_case_filed
                      : "Housing Court Cases - N/A"
                  }
                >
                  <span
                    className={
                      item?.check_list?.housing_court_case === 2
                        ? `${styles.MandateCheckSec} ${styles.Fail}`
                        : item?.check_list?.housing_court_case === 1
                        ? `${styles.MandateCheckSec} ${styles.Active}`
                        : `${styles.MandateCheckSec}`
                    }
                  >
                    <img src="/static/img/court-cases-icon.svg" alt="" />
                  </span>
                </Tooltip>
                {item?.afford_amount !== "" &&
                  item?.check_list?.income === 2 && (
                    <span
                      className={`${styles.ProspectDeclinedBadge} ${styles.AffordBadge}`}
                    >
                      Afford: ${item?.afford_amount}
                    </span>
                  )}
                {item?.afford_amount !== "" &&
                  item?.check_list?.income === 1 && (
                    <span
                      className={`${styles.ProspectApprovedBadge} ${styles.AffordBadge}`}
                    >
                      Afford: ${item?.afford_amount}
                    </span>
                  )}
              </div>
            )} */}
            <div className={`${styles.ProsUserMandateSec}`}>
              <Tooltip
                title={
                  item?.credit_score !== ""
                    ? "Credit Score - " + item?.credit_score
                    : "Credit Score - N/A"
                }
              >
                <span
                  className={
                    item?.check_list?.credit_score === 2
                      ? `${styles.MandateCheckSec} ${styles.Fail}`
                      : item?.check_list?.credit_score === 1
                        ? `${styles.MandateCheckSec} ${styles.Active}`
                        : `${styles.MandateCheckSec}`
                  }
                >
                  <img src="/static/img/credit-score-icon.svg" alt="" />
                </span>
              </Tooltip>
              <Tooltip
                title={getSlaTooltipData(item)}
              >
                <span
                  className={
                    item?.check_list?.income === 2
                      ? `${styles.MandateCheckSec} ${styles.Fail}`
                      : item?.check_list?.income === 1
                        ? `${styles.MandateCheckSec} ${styles.Active}`
                        : `${styles.MandateCheckSec}`
                  }
                >
                  <img src="/static/img/salary-icon.svg" alt="" />
                </span>
              </Tooltip>
              <Tooltip
                title={
                  item?.ever_had_bankruptcy !== ""
                    ? "Bankruptcy - " + item?.ever_had_bankruptcy
                    : "Bankruptcy - N/A"
                }
              >
                <span
                  className={
                    item?.check_list?.bankruptcy === 2
                      ? `${styles.MandateCheckSec} ${styles.Fail}`
                      : item?.check_list?.bankruptcy === 1
                        ? `${styles.MandateCheckSec} ${styles.Active}`
                        : `${styles.MandateCheckSec}`
                  }
                >
                  <img src="/static/img/bankruptcy-icon.svg" alt="" />
                </span>
              </Tooltip>
              <Tooltip
                title={
                  item?.ever_case_filed !== ""
                    ? "Housing Court Cases - " + item?.ever_case_filed
                    : "Housing Court Cases - N/A"
                }
              >
                <span
                  className={
                    item?.check_list?.housing_court_case === 2
                      ? `${styles.MandateCheckSec} ${styles.Fail}`
                      : item?.check_list?.housing_court_case === 1
                        ? `${styles.MandateCheckSec} ${styles.Active}`
                        : `${styles.MandateCheckSec}`
                  }
                >
                  <img src="/static/img/court-cases-icon.svg" alt="" />
                </span>
              </Tooltip>
              {item?.afford_amount !== "" && item?.check_list?.income === 2 && (
                <span
                  className={`${styles.ProspectDeclinedBadge} ${styles.AffordBadge}`}
                >
                  Afford: ${item?.afford_amount}
                </span>
              )}
              {item?.afford_amount !== "" && item?.check_list?.income === 1 && (
                <span
                  className={`${styles.ProspectApprovedBadge} ${styles.AffordBadge}`}
                >
                  Afford: ${item?.afford_amount}
                </span>
              )}
            </div>
          </div>
        </div>
      </div>

      <Dialog
        open={openLeaderBoardModal}
        fullWidth
        maxWidth="sm"
        onClose={(e) => setOpenLeaderBoardModal(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="NewPopUp"
      >
        <DialogTitle id="alert-dialog-title">
          Are you sure you want to remove from leader board?
          <button onClick={(e) => setOpenLeaderBoardModal(false)}>
            <X />
          </button>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <div className="ModalFormGroup">
              <label className="PopupBodyText">
                The Leaderboard Record will be remove from leader board list
                immediately. You can add to leader board it at any time.
              </label>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={(e) => setOpenLeaderBoardModal(false)}
            className="CancelPopupBU"
          >
            Cancel
          </Button>
          <Button
            onClick={(e) => removeFromLeaderBoard()}
            className="SubmitPopupBU"
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ProspectCard;
